<template>
    <div id="Home">
         <div class="mainbox">
            <div class="title"><i class="fas fa-recycle"></i> Vue.js Composition API Examples</div>
            <div class="content">
                We will see the differences between these 3 ways to design our Vue.js 3 architecture: <strong>Options-Based API</strong>, <strong>Composition API</strong>, <strong>Reusable Composition API</strong>
            </div>
        </div><!-- mainbox-->
    </div>
</template>

<script>
export default {
    name: 'Home'
}
</script>